import { useEffect } from 'react';

const DEFAULT_PRINT_DELAY_MS = 400;

/**
 * Opens the browser's print dialog while `isPrinting` is true, after `delayMs` (long enough for
 * charts to redraw at the print width), and calls `onClose` when printing ends (printed or
 * cancelled). `pageStyle` (e.g. a landscape `@page` rule) is added to the page only for that time,
 * so printing elsewhere in the app is unaffected.
 */
export const usePrintView = (
  isPrinting: boolean,
  onClose: () => void,
  pageStyle?: string,
  delayMs = DEFAULT_PRINT_DELAY_MS
): void => {
  useEffect(() => {
    if (!isPrinting) return undefined;
    const style = document.createElement('style');
    if (pageStyle) {
      style.textContent = pageStyle;
      document.head.appendChild(style);
    }
    const timeout = setTimeout(() => window.print(), delayMs);
    window.addEventListener('afterprint', onClose);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener('afterprint', onClose);
      style.remove();
    };
  }, [delayMs, isPrinting, onClose, pageStyle]);
};
